module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_90deg.7e052f9d.png";